module.exports = __webpack_public_path__ + "img/top_bg.0b7ef07a.jpg";